import { useState } from "react";
import Teams from "./Teams";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Leaderboard from "./Leaderboard";

export default function Home() {
  const [showBanner, setShowBanner] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <div>
      {/* Department Rankings Section */}
      <section className="bg-white p-4 mb-6">
        <div className="flex flex-col items-center text-center">
          <div className="flex items-center space-x-2 mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="w-8 h-8 text-yellow-500"
              viewBox="0 0 24 24"
            >
              <path d="M8 21h8v-2H8v2zm4-19a5 5 0 0 0-5 5v1H4a1 1 0 0 0-1 1v3c0 2.2 1.8 4 4 4h.1a6.9 6.9 0 0 0 5.9 4v2H10v2h4v-2h-2v-2a6.9 6.9 0 0 0 5.9-4H17c2.2 0 4-1.8 4-4v-3a1 1 0 0 0-1-1h-3v-1a5 5 0 0 0-5-5z" />
            </svg>
            <h2 className="text-2xl font-extrabold tracking-wide font-orbitron">
              Official Leaderboard
            </h2>
          </div>
          <div className="flex items-center space-x-3">
            <span className="ml-2 bg-yellow-500 text-white px-3 py-1 rounded-full flex items-center animate-pulse">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                className="w-4 h-4 mr-1"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="8" />
              </svg>
              LIVE
            </span>
            
          </div>
        </div>
      </section>

      {/* Welcome Banner */}
      {showBanner && (
        <div className="bg-yellow-500 text-white p-4 mb-6 rounded-lg flex items-center justify-between">
          <div className="flex items-start">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
              className="w-12 h-12 mr-4 animate-bounce"
            >
              <path d="M21 3a1 1 0 0 0-1.447-.894L4 10H2v4h2l1.342 2.684a4 4 0 1 0 6.628 4.45L14 20h1a1 1 0 0 0 1-1v-3.382l4.553 2.276A1 1 0 0 0 22 17V4a1 1 0 0 0-1-1Z" />
            </svg>
            <div>
              <h3 className="text-lg font-bold">Welcome to SNSU PALAKASAN 2025!</h3>
              <p className="text-sm">
                Stay updated with the latest scores. Check back regularly for
                results!
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowBanner(false)}
            className="text-white hover:text-gray-300"
          >
            ✖
          </button>
        </div>
      )}

      {/* Hero Section */}
      <section
        className="relative text-center mb-12 bg-cover bg-center"
        style={{ backgroundImage: "url('/images/back.png')" }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50" />
        <div className="relative z-10 py-20 px-4">
          <h1 className="text-4xl md:text-5xl font-extrabold text-yellow-400 mb-4 drop-shadow-lg">
            SNSU PALAKASAN 2025
          </h1>
          <p className="text-lg md:text-xl text-white max-w-3xl mx-auto mb-6">
            The annual athletic and cultural festival of Surigao del Norte State
            University!
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-white font-semibold">
            <div className="bg-white bg-opacity-20 px-4 py-2 rounded-lg">
              🏆 10 Sports & 24 Cultural Events
            </div>
            <div className="bg-white bg-opacity-20 px-4 py-2 rounded-lg">
              🎉 5 Days of Non-stop Action
            </div>
            <div className="bg-white bg-opacity-20 px-4 py-2 rounded-lg">
              📍 SNSU Main Campus
            </div>
          </div>
        </div>
      </section>

      {/* Leaderboard */}
      <Leaderboard />

      {/* Teams */}
      <Teams />

<div className="my-8" />

{/* NEW 2025 GALLERY SECTION */}
<section className="mb-12">
  <h2 className="text-2xl font-bold mb-4 text-center">
    Palakasan 2025 Gallery
  </h2>

  <Slider {...carouselSettings}>
    {[
      "PALAKASAN.jpg",
      "COE1.jpg",
      "CTE1.jpg",
      "CLASS1.jpg",
      "CBT1.jpg",
      "CCIS1.jpg"
    ].map((img, idx) => (
      <div key={idx} className="px-2">
        <div className="relative rounded-lg shadow-lg">
          <img
            src={`/images/${img}`}
            alt="Palakasan 2025"
            onClick={() => setSelectedImage(`/images/${img}`)}
            className="cursor-pointer w-full h-64 object-cover rounded-lg"
          />
        </div>
      </div>
    ))}
  </Slider>
</section>


     {/* Gallery Carousel */}
<section className="mb-12">
  <h2 className="text-2xl font-bold mb-4 text-center">
    2024 Intramurals Throwback
  </h2>

  <Slider {...carouselSettings}>
    {[
      "img1.jpg",
      "img2.jpg",
      "img3.jpg",
      "img4.jpg",
      "img5.jpg",
      "img6.jpg",
      "img7.jpg",
      "img8.jpg"
    ].map((img, idx) => (
      <div key={idx} className="px-2">
        <div className="relative rounded-lg shadow-lg">
          <img
            src={`/images/${img}`}
            alt="Intramurals"
            className="w-full h-64 object-cover cursor-pointer rounded-lg"
            onClick={() => setSelectedImage(`/images/${img}`)}
          />
        </div>
      </div>
    ))}
  </Slider>
</section>

{/* Image Modal */}
{selectedImage && (
  <div
    className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
    onClick={() => setSelectedImage(null)}
  >
    <img
      src={selectedImage}
      alt="Preview"
      className="
        max-w-[100vw]
        max-h-[100vh]
        object-contain
        rounded-lg
      "
    />

    <button
      onClick={() => setSelectedImage(null)}
      className="absolute top-5 right-5 text-white text-3xl"
    >
      ✕
    </button>
  </div>
)}


      {/* Recap Video */}
      <section className="mb-12 text-center">
        <h2 className="text-2xl font-bold mb-4">Watch Last Year’s Highlights</h2>
        <div className="w-full max-w-3xl mx-auto">
          <iframe
            src="https://www.youtube.com/embed/rltyfmukczQ"
            title="Intramurals Highlights"
            className="w-full h-[500px] md:h-[450px] sm:h-[300px] rounded-lg shadow-lg"
            allowFullScreen
          />
        </div>
      </section>

      {/* Fun Stats */}
      <section className="bg-gradient-to-r py-8 mb-12">
        <div className="max-w-xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            { icon: "👥", number: "4,000+", label: "Students" },
            { icon: "🏫", number: "5", label: "Colleges" },
            { icon: "🏅", number: "34", label: "Events" },
            { icon: "🏆", number: "2", label: "Champions" }
          ].map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl shadow-md p-4 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="text-3xl mb-2">{item.icon}</div>
              <p className="text-lg font-extrabold text-yellow-400">
                {item.number}
              </p>
              <p className="text-sm text-gray-600 font-medium">{item.label}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
